export default {"src":"/_next/static/media/consent.dcfd96ad.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};